import { getMovies } from "../Api/index";

export default {
    state: {
        uzbList: [
            {
                key: "uzbList_films",
                data: null,
                title: "Filmlar",
                pageTitlte: "Hamma Filmlar",
                id: 254
            },
            {
                key: "uzbList_dorama",
                data: null,
                title: "Dorama",
                pageTitlte: "Hamma Dorama",
                id: 258
            },
            {
                key: "uzbList_baby",
                data: null,
                title: "Bolalarga",
                pageTitlte: "Hamma Bolalarga",
                id: 259
            },
            {
                key: "uzbList_concerts",
                data: null,
                title: "Konsertlar",
                pageTitlte: "Hamma Konsertlar",
                id: 256
            },
            {
                key: "uzbList_serials",
                data: null,
                title: "Seriallar",
                pageTitlte: "Hamma Seriallar",
                id: 255
            },

            {
                key: "uzbList_anime",
                data: null,
                title: "Anime",
                pageTitlte: "Hamma Anime",
                id: 257
            }
        ],
        getIsListLoaded: false
    },
    mutations: {
        SET_UZBLIST(state, payload) {
            const { response, key } = payload;
            state.uzbList = state.uzbList.map(e => {
                if (e.key === key) {
                    e.data = response;
                }
                return e;
            });
        },
        SET_ISLISTLOADED(state, payload) {
            state.getIsListLoaded = payload;
        },
        RESET_UZBLIST(state) {
            state.uzbList.forEach(e => {
                e.data = null;
            });
        }
    },

    actions: {
        async getMovies(context, payload) {
            context.commit("SET_ISLISTLOADED", false);
            const response = await getMovies(
                payload.isLoggedIn,
                payload.params
            );
            context.commit("SET_ISLISTLOADED", true);
            context.commit("SET_UZBLIST", { response, key: payload.key });
        }
    },

    getters: {
        getUzbState(state) {
            return state.uzbList;
        },
        getIsListLoaded(state) {
            return state.getIsListLoaded;
        }
    }
};
